import { dayFactor } from '@app/shared/price-calc';
import { formatDecimal, parseScaled } from '../ui/numbers';

/** "33,33" (percent typed by a person) -> 3333 bp; 0–1000%, at most two decimals. Null when not valid. */
export function pctToBp(text: string): number | null {
  const bp = parseScaled(text.trim().replace(/%$/, ''), 2, { maxIntegerDigits: 4 });
  return bp === null || bp > 100_000 ? null : bp;
}

/** 3333 -> "33,33" */
export const bpToPct = (bp: number): string => formatDecimal(bp / 100);

/** "1,5" -> 1500 (days in thousandths); at least 0,5, at most three decimals. Null when not valid. */
export function daysToMilli(text: string): number | null {
  const milli = parseScaled(text, 3, { maxIntegerDigits: 3 });
  return milli === null || milli < 500 ? null : milli;
}

/** 1500 -> "1,5" */
export const milliToDays = (milli: number): string => formatDecimal(milli / 1000);

const dayWord = (n: number) => (n === 1 ? 'dzień' : 'dni');

/** "1 dzień = 100% · 2 dni = 150% · 3 dni = 180% · 5 dni = 240%": the same calculation as quotes (`@app/shared`). */
export function schemePreview(pctsBp: readonly number[], days: readonly number[] = [1, 2, 3, 5]): string {
  return schemePreviewParts(pctsBp, days).join(' · ');
}

/** The parts of `schemePreview` ("3 dni = 180%"), e.g. to keep each on one line. */
export function schemePreviewParts(pctsBp: readonly number[], days: readonly number[] = [1, 2, 3, 5]): string[] {
  return days.map((n) => {
    // bp·thousandths -> percent with at most two decimals
    const pct = Number(dayFactor(n * 1000, pctsBp)) / 100_000;
    return `${n} ${dayWord(n)} = ${formatDecimal(Math.round(pct * 100) / 100)}%`;
  });
}

/** "100% / 50% / 30%" */
export const schemeText = (pctsBp: readonly number[]): string => pctsBp.map((p) => `${bpToPct(p)}%`).join(' / ');
